import React from 'react';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import Form from 'apps/auth/components/form-multi/Form';
import InputText from 'apps/auth/components/form-multi/InputText';
import ModalError from 'apps/auth/components/utils/ModalError';
import { SEND_STATEMENT_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { STATEMENT_SUCCESS_SCREEN } from 'apps/auth/constants/Constants';
import { TRANSFER_STATEMENT } from 'apps/auth/constants/formName';
import { AUTH_PROFILE_STATEMENT_EMAIL_ACTION } from 'apps/auth/constants/UrlConstants';
import { useFields, usePageMessages } from 'apps/auth/hooks/selectors';

const EmailScreen = (props) => {
    const fields = useFields(TRANSFER_STATEMENT);
    const { enterEmailTitler, enterEmailText, getStatement, goBack, contactSupport, somethingWentWrong } = usePageMessages();

    const submitHandler = (_fields, json) => {
        if (json?.errors && Object.keys(json.errors)?.length > 0) {
            props.modalRef.current?.open(
                <ModalError
                    headerText={somethingWentWrong}
                    buttonRowCaption={contactSupport}
                    buttonRowOnClick={() => props.toggleChat(true)}
                    primaryButtonCaption={goBack}
                    primaryButtonOnClick={() => props.modalRef.current?.close()}
                />,
            );
        } else {
            props.switchToNextScreen(STATEMENT_SUCCESS_SCREEN);
        }
    };

    return (
        <>
            <HeaderPanel title={enterEmailTitler} subtitle={enterEmailText} />
            <Form id="email_screen" action={AUTH_PROFILE_STATEMENT_EMAIL_ACTION} formName={TRANSFER_STATEMENT} fields={fields} onSubmitHandler={submitHandler}>
                <InputText field={fields.email} formName={TRANSFER_STATEMENT} focus={true} isNewInput />
                <FixedBottomPanel isRightAligned buttonPosition={props.buttonPosition}>
                    <Button type="submit" raised={true} caption={getStatement} onClick={() => amplitude.getInstance().logEvent(SEND_STATEMENT_CLICKED)} />
                </FixedBottomPanel>
            </Form>
        </>
    );
};

EmailScreen.propTypes = {
    modalRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    toggleChat: PropTypes.func.isRequired,
    switchToNextScreen: PropTypes.func.isRequired,
};

export default EmailScreen;
